import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#ff575c",
            light: "#ff575c",
            dark: "#ff575c",
            contrastText: "#fff",
        },
        black: {
            light: "#000",
            main: "#000",
            dark: "#000",
            contrastText: "#fff",
        },
        blue: {
            light: "#017afd",
            main: "#017afd",
            dark: "#017afd",
            contrastText: "#fff",
        },
        grey2: {
            light: "#ccc",
            main: "#333",
            dark: "#333",
            contrastText: "#fff",
        },
    },
});
